/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Body_Fat_WordsInputs */

const en_us2_search_field_body_fat_words = /** @type {(inputs: Search_Field_Body_Fat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fat bf body composition percentage`)
};

const pt_br2_search_field_body_fat_words = /** @type {(inputs: Search_Field_Body_Fat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gordura bf composicao corporal`)
};

const es_419_search_field_body_fat_words = /** @type {(inputs: Search_Field_Body_Fat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`grasa bf composicion corporal porcentaje`)
};

const pt_pt2_search_field_body_fat_words = /** @type {(inputs: Search_Field_Body_Fat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gordura bf composicao corporal percentagem`)
};

const fr_fr2_search_field_body_fat_words = /** @type {(inputs: Search_Field_Body_Fat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`graisse masse grasse bf composition corporelle pourcentage`)
};

const de_de2_search_field_body_fat_words = /** @type {(inputs: Search_Field_Body_Fat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fett kfa körperzusammensetzung prozent körperfett`)
};

const it_it2_search_field_body_fat_words = /** @type {(inputs: Search_Field_Body_Fat_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`grasso bf composizione corporea percentuale`)
};

/**
* | output |
* | --- |
* | "fat bf body composition percentage" |
*
* @param {Search_Field_Body_Fat_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_body_fat_words = /** @type {((inputs?: Search_Field_Body_Fat_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Body_Fat_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_body_fat_words(inputs)
	if (locale === "es-419") return es_419_search_field_body_fat_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_body_fat_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_body_fat_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_body_fat_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_body_fat_words(inputs)
	return en_us2_search_field_body_fat_words(inputs)
});
export { search_field_body_fat_words as "search.field_body_fat_words" }